import { render, staticRenderFns } from "./BlackGoldGameFrameModal.vue?vue&type=template&id=3ebf492f"
import script from "./BlackGoldGameFrameModal.vue?vue&type=script&lang=js"
export * from "./BlackGoldGameFrameModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports